import React from 'react';

import {
  Flex, ModalContent, Spinner, Text,
} from '@chakra-ui/react';

import { Modal, Icon } from 'components';
import { labels } from 'constants/FormBuilder';

import FormBuilder from './FormBuilder';

interface FormModalProps {
  isOpen: boolean
  isFetching: boolean
  onClose: () => void
  content: string
  action: 'Novo' | 'Editar' | 'Atribuir'
  defaultValues?: any
  onSuccess?: () => void
}
export default function FormModal({
  isOpen, onClose, content, action, defaultValues, onSuccess, isFetching,
}: FormModalProps) {
  return (
    <Modal
      size="xl"
      onClose={onClose}
      isOpen={isOpen}>
      <ModalContent
        p={3}>
        <Flex
          width="100%"
          justifyContent="space-between"
          alignItems="center">
          <Text
            variant="mediumBold"
            color="primary.default">
            {`${action} ${labels[content]}`}
          </Text>
          <Icon
            cursor="pointer"
            onClick={onClose}
            color="gray"
            name="times"
          />
        </Flex>
        <Flex
          hidden={!isFetching}
          position="absolute"
          inset={0}
          alignItems="center"
          justifyContent="center"
          zIndex={1100}
          bg="gray.transparent">
          <Spinner
            zIndex={1200}
            color="secondary.500"
            size="lg"
            thickness="4px"
          />
        </Flex>
        <FormBuilder
          onSuccess={onSuccess}
          defaultValues={defaultValues}
          content={content}
          onClose={onClose}
        />
      </ModalContent>
    </Modal>
  );
}
